"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defualtDialogVM = exports.DialogPM = void 0;
class DialogPM {
    updateAlertObserver(alert) {
        if (alert === this.observingDialog)
            return;
        if (this.observingDialog !== null) {
            this.observingDialog.removeObserver(this.doUpdateView);
        }
        if (alert !== null) {
            alert.addObserver(this.doUpdateView);
        }
        this.observingDialog = alert;
    }
    vmHasChanged(vm) {
        var _a, _b, _c;
        if (this.lastVM === undefined)
            return true;
        if (vm === null && this.lastVM === null)
            return false;
        if ((vm === null || vm === void 0 ? void 0 : vm.open) === ((_a = this.lastVM) === null || _a === void 0 ? void 0 : _a.open) &&
            (vm === null || vm === void 0 ? void 0 : vm.type) === ((_b = this.lastVM) === null || _b === void 0 ? void 0 : _b.type) &&
            (vm === null || vm === void 0 ? void 0 : vm.dialog) === ((_c = this.lastVM) === null || _c === void 0 ? void 0 : _c.dialog)) {
            return false;
        }
        return true;
    }
    constructor(repo, updateView) {
        this.repo = repo;
        this.updateView = updateView;
        this.observingDialog = null;
        this.doUpdateView = () => {
            let vm = { open: false };
            const currentDialog = this.repo.activeDialog;
            if (currentDialog) {
                this.updateAlertObserver(currentDialog);
                vm = {
                    open: currentDialog.isOpen,
                    type: currentDialog.type,
                    dialog: currentDialog,
                    preventOutsideDismiss: currentDialog.preventOutsideDismiss
                };
            }
            else {
                this.updateAlertObserver(null);
            }
            if (!this.vmHasChanged(vm))
                return;
            this.updateView(vm);
            this.lastVM = vm;
        };
        this.dispose = () => {
            this.repo.removeObserver(this.doUpdateView);
            if (this.observingDialog) {
                this.observingDialog.removeObserver(this.doUpdateView);
            }
        };
        repo.addObserver(this.doUpdateView);
        this.doUpdateView();
    }
}
exports.DialogPM = DialogPM;
exports.defualtDialogVM = {
    open: false
};
